import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DropDownMenu.css';
import dropDown from '../Images/DropDown.png';

interface Page {
  title: string;
  url: string;
}

interface DropdownMenuProps {
  pages: Page[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ pages }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);

  const toggleDropdown = (): void => {
    if (isOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setIsOpen(true);
    }
  };

  const handleLinkClick = (): void => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 300);
  };

  return (
    <div className="dropdown-container">
      <button
        className="dropdown-toggle"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
      >
        <img src={dropDown} alt="Menu" className="logo" />
      </button>
      {(isOpen || isClosing) && (
        <ul className={`dropdown-menu ${isClosing ? 'hidden' : ''}`}>
          {pages.map((page: Page, index: number) => (
            <li key={index} className="dropdown-item">
              <Link
                to={page.url}
                className="dropdown-link"
                onClick={handleLinkClick}
              >
                {page.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownMenu;
